import React from 'react';
import { Drawer, Button, Space, Form } from 'antd';
import SupplierForm from './SupplierForm';
import { CreateSupplierData, UpdateSupplierData, Supplier } from '../../services/supplierService';

interface SupplierModalProps {
  visible: boolean;
  supplier?: Supplier;
  onSave: (data: CreateSupplierData | UpdateSupplierData) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

const SupplierModal: React.FC<SupplierModalProps> = ({
  visible,
  supplier,
  onSave,
  onCancel,
  loading = false,
}) => {
  const isEdit = !!supplier;
  const [form] = Form.useForm();

  return (
    <Drawer
      title={isEdit ? 'Cập nhật nhà cung cấp' : 'Thêm nhà cung cấp mới'}
      open={visible}
      onClose={onCancel}
      width={600}
      destroyOnClose
      extra={
        <Space>
          <Button onClick={onCancel}>
            Hủy
          </Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            {isEdit ? 'Cập nhật' : 'Thêm'}
          </Button>
        </Space>
      }
    >
      <SupplierForm
        supplier={supplier}
        onSave={onSave}
        onCancel={onCancel}
        loading={loading}
        noCard={true}
        form={form}
        hideActions
      />
    </Drawer>
  );
};

export default SupplierModal; 